<div class="row wrapper border-bottom white-bg page-heading info-projeto">
  <div class="col-lg-10 title-projeto">
    <h2>Projeto</h2>
  </div>
</div>
<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <div class="info-page">
            <h3>{{ actionLabel }} Produto</h3>
          </div>

          <form [formGroup]="form">
            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Produto<sup class="text-danger ms-2">*</sup></label>
                <textarea rows="4" id="description" class="form-control" formControlName="description"></textarea>
                <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
              </div>
            </div>
            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Unidade de medida</label>
                <ng-select id="unit_id" class="ng-select-alternative" [items]="filters?.unitIdSelect" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="unit_id"></ng-select>
                <app-field-message [field]="fieldMessageRequired('unit_id')" [erros]="fieldErros('unit_id')"></app-field-message>
              </div>
            </div>
            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Meta</label>
                <input type="text" id="ds_goal" class="form-control text-right" formControlName="ds_goal" (keyup)="formatarMedidaFisica('ds_goal', 2)" />
                <app-field-message [field]="fieldMessageRequired('ds_goal')" [erros]="fieldErros('ds_goal')"></app-field-message>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
                <label class="col-sm-12 pb-1">Custo estimado</label>
                <input type="text" id="value" class="form-control text-right" formControlName="value" (keyup)="formatarMedidaFisica('value', 2)" />
                <app-field-message [field]="fieldMessageRequired('value')" [erros]="fieldErros('value')"></app-field-message>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
                <label class="col-sm-12 pb-1">Tempo de Execução (meses)</label>
                <input type="text" id="exec_duration" class="form-control text-right" formControlName="exec_duration" (keyup)="maskNumber($event, 'exec_duration')" />
                <app-field-message [field]="fieldMessageRequired('exec_duration')" [erros]="fieldErros('exec_duration')"></app-field-message>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
                <label class="col-sm-12 pb-1">Modalidade de execução/aquisição</label>
                <ng-select id="prod_template_id" class="ng-select-alternative" [items]="filters?.templateIdSelect" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="prod_template_id" (change)="changeProdTemplate()"></ng-select>
                <app-field-message [field]="fieldMessageRequired('prod_template_id')" [erros]="fieldErros('prod_template_id')"></app-field-message>
              </div>
            </div>

            <!-- Table -->
            <div class="form-group row m-b">
              <div class="col-12 col-sm-10">
                <label class="col-sm-12 pb-1">Etapa e/ou documento necessário</label>
                <div class="system-table table-container system-table-m-b table-form">
                  <div class="system-table-conteiner system-table-form-conteiner system-table-select">
                    <table>
                      <thead>
                        <tr>
                          <th>Etapa e/ou documento</th>
                          <th>Obrigatória?</th>
                          <th>Status</th>
                          <th class="text-center btn-icon-td">Ações</th>
                        </tr>
                      </thead>
                      <tbody formArrayName="steps">
                        <tr *ngFor="let item of getFormArray().controls; let i = index" [formGroupName]="i">
                          <td class="title">
                            {{item?.value?.name}}
                          </td>
                          <td>
                            <ng-select class="ng-select-alternative" [items]="filters?.statusList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="comtemplated" [clearable]="false">
                            </ng-select>
                            <app-field-message [field]="fieldMessageRequireds('comtemplated', i)" [erros]="fieldErrosFormArray('comtemplated', i)"></app-field-message>
                          </td>
                          <td>
                            <ng-select class="ng-select-alternative" [items]="filters?.statusList2" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="prod_step_stat_id" [clearable]="false">
                            </ng-select>
                            <app-field-message [field]="fieldMessageRequireds('prod_step_stat_id', i)" [erros]="fieldErrosFormArray('prod_step_stat_id', i)"></app-field-message>
                          </td>
                          <td>
                            <div class="btn-icon">
                              <span class="icon-table icon-red" (click)="removeField(i)" *ngIf="!entity?.id || (entity?.id && entity?.can_save)">
                                <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
                              </span>
                            </div>
                          </td>
                        </tr>
                        <tr *ngIf="!getFormArray().controls.length" class="border-b-radius">
                          <td colspan="4" class="text-center">Nenhuma Etapa e/ou documento Cadastrada</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <button class="btn btn-success btn-add-question mb-0" type="button" *ngIf="!entity?.id || (entity?.id && entity?.can_save)" (click)="openEtapaModal()">Nova Etapa e/ou documento</button>
                </div>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end m-b">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-danger m-r-xxl btn-excluir" *ngIf="entity?.id && entity?.can_save" (click)="confirmExcluir()" type="button">Excluir</button>
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button class="btn btn-primary" type="btn" *ngIf="entity?.id && entity?.can_save" (click)="update()">Salvar</button>
                <button class="btn btn-primary" type="btn" *ngIf="!entity?.id" (click)="salvar()">Salvar</button>
              </div>
            </div>
          </form>

          <app-historico-atualizacoes-list *ngIf="entity?.id" [audit]="audit"></app-historico-atualizacoes-list>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modalEtapa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Lista de etapa e/ou documento</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeEtapaModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Etapa e/ou documento</label>
        <ng-select class="ng-select-alternative" [items]="filters?.proddocList" bindLabel="name" placeholder="Selecione" [(ngModel)]="proddoc">
        </ng-select>
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closeEtapaModal()">Fechar</button>
        <button class="btn btn-primary" type="button" [disabled]="!proddoc" (click)="addField()">Adicionar</button>
      </div>
    </div>
  </div>
</ng-template>

<app-loading [loader]="isLoading"></app-loading>